var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98741 6.11205C9.98714 6.67192 9.77684 7.20875 9.40276 7.60444C9.02868 8.00013 8.52147 8.22227 7.99271 8.22199C7.46394 8.22171 6.95694 7.99903 6.58324 7.60295C6.20953 7.20686 5.99974 6.66981 6 6.10994C6.00026 5.55007 6.21057 5.01324 6.58465 4.61755C6.95873 4.22186 7.46594 3.99972 7.9947 4C8.52346 4.00028 9.03047 4.22296 9.40417 4.61904C9.77788 5.01513 9.98767 5.55218 9.98741 6.11205ZM10.0472 9.78518H6.05981V23H10.0472V9.78518ZM16.3473 9.78518H12.3799V23H16.3075V16.0654C16.3075 12.2023 21.0624 11.8434 21.0624 16.0654V23H25V14.6299C25 8.11749 17.9622 8.36026 16.3075 11.5584L16.3473 9.78518Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.b0fb8fd699129fcd6ad9f1a0970181d6.svg";
export { ForwardRef as ReactComponent };